import { Theme } from "wg-themer";

export const themes: Array<Theme> = [
  // {
  //   darkMode: false,
  //   secondary: '#f9f3e9',
  //   accent:"#8C8C8C",
  //   primary: '#2a0c08',
  //   label: 'Woodgrove Groceries',
  //   value: 'groceries',
  //   customValues:{
  //     '--app-primary':'#2a0c08',
  //     '--app-secondary':'#f9f3e9',
  //     '--app-primary-font':'#FFFFFF',
  //     '--app-secondary-font': '#8C8C8C',
  //     '--app-qr-color':"#952819"
  //   }
  // },
  // {
  //   darkMode: false,
  //   secondary: '#B5DDDD',
  //   accent:"#8C8C8C",
  //   primary: '#2D3338',
  //   label: 'Woodgrove Health',
  //   value: 'health',
  //   customValues:{
  //     '--app-primary':'#2D3338',
  //     '--app-secondary':'#B5DDDD',
  //     '--app-primary-font':'#FFFFFF',
  //     '--app-secondary-font': '#8C8C8C',
  //     '--app-qr-color':"#179797"
  //   }
  // },
  {
    darkMode: false,
    secondary: '#dbeadd',
    accent:"#8C8C8C",
    primary: '#212121',
    label: 'Woodgrove Employee',
    value: 'banking',
    customValues:{
      '--app-primary':'#212121',
      '--app-secondary':'#dbeadd',
      '--app-primary-font':'#FFFFFF',
      '--app-secondary-font': '#8C8C8C',
      '--app-qr-color':"#039045"
    }
  },
  {
    darkMode: false,
    secondary: '#fff0eb',
    accent:"#8C8C8C",
    primary: '#B5100D',
    label: 'Woodgrove Finance',
    value: 'finance',
    customValues:{
      '--app-primary':'#B5100D',
      '--app-secondary':'#fff0eb',
      '--app-primary-font':'#FFFFFF',
      '--app-secondary-font': '#FFFFFF',
      '--app-qr-color':'#B5100D'
    }
  }
];
